import { fileUrl } from 'api';
import {
  LightingSolution,
  Room,
  RoomTypeLink,
  Slug
  } from 'type';

const hasEqualSlug = (altA?: { slug: Slug }, altB?: { slug: Slug }) => {
  if (!altA || !altB) {
    return false;
  }

  return altA?.slug?.current === altB?.slug?.current;
};

const isRoomTypeValid = (roomTypeLink: RoomTypeLink) =>
  Boolean(roomTypeLink?.slugName);

const getAllRoomImages = (room: Room) => {
  const extractRoomImages = (lightingSolution: LightingSolution) =>
    lightingSolution.roomImages;

  return room.lightingSolutions
    .flatMap(extractRoomImages)
    .map((img) => fileUrl(img));
  // .map((img) => imageUrl(img).toString());
};

export const RoomUtil = {
  isRoomTypeValid,
  hasEqualSlug,
  getAllRoomImages,
};
